<template>
  <div class="tags swiper" ref="tags">
    <div class="swiper-wrapper">
      <!-- tag--active -->
      <div class="swiper-slide tag" v-for="item in data">
        <RouterLink :to="`/catalog/${item.id}`">
          {{ item.name }}
        </RouterLink>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
  import { ISectionsItem } from "@/models/models";
  import Swiper from "swiper";
  import { onMounted, PropType, ref } from "vue";
  import { RouterLink } from "vue-router";

  const props = defineProps({
    data: {
      type: Object as PropType<Array<ISectionsItem>> | null,
      required: true,
    },
  });

  const tags = ref(null as unknown as HTMLElement);

  onMounted(() => {
    if (tags.value) {
      new Swiper(tags.value, {
        slidesPerView: "auto",
        spaceBetween: 8,
      });
    }
  });
</script>
<style lang="scss">
  .tag {
    width: max-content !important;
    white-space: nowrap;
    color: $darkGreen;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    padding: 8px;
    border-radius: 4px;
    background-color: $lightGray;

    a {
      color: #25472f;
    }

    &--active {
      background-color: $lightGreen;
    }
  }
</style>
